import { defineRecipe } from '@chakra-ui/react';

export const iconRecipe = defineRecipe({
  defaultVariants: {
    size: 'md',
  } as any, // TODO: we need to wait for chakra-ui to fix typings here
});
